import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../authSlice";

export const sendRestorePasswordLink = createAsyncThunk<
    any,
    any,
    { rejectValue: { message: string } }
>("auth/sendRestorePasswordLink", async (email: any, thunkAPI) => {
    try {
        const response = await fetch(`${API}/v1/users/me/password/recovery/codes`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email
            })
        });

        let data = await response.json();

        if (response.status === 200) {
            return data;
        } else {
            throw new Error(data.message);
        }
    } catch (error: any) {
        return thunkAPI.rejectWithValue({ message: error.message });
    }
});